'use strict';

module.exports = function isPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/helpers/isPropertyKey.js
// module id = 128
// module chunks = 8